import PageLoader from '@/components/ui/PageLoader/PageLoader';
import { mapState } from 'vuex';
import store from '@/store/store';
import apiClient from '@/apiClient';

import PaymentsList from '@/components/billing/PaymentsList/PaymentsList.vue';
import PlanModal from '@/components/billing/PlanModal/PlanModal.vue';
import PlanSelect from '@/components/billing/PlanSelect/PlanSelect.vue';
import PaymentModal from '@/components/billing/PaymentModal/PaymentModal.vue';
import ConfirmModal from '@/components/ui/modals/ConfirmModal/ConfirmModal.vue';
import TutorialModal from '@/components/ui/modals/TutorialModal/TutorialModal.vue';

export default {
  data() {
    return {
      loaded: false,
      columns: [
        { label: 'Дата', field: 'created_at' },
        { label: 'Приход', field: 'amount' },
        { label: 'Расход', field: 'amount' },
        { label: 'Статус', field: 'status' },
        { label: 'Описание операции', field: 'reason_title' }
      ],
      rows: []
    };
  },

  computed: {
    ...mapState({
      packages: state => state.payments.packages,
      balance: state => state.billing.balance,
      billing: state => state.billing.userBilling,
      userTarif: state => state.billing.userBilling.tariff,
      currency: state => state.billing.currency,
      payments: state => state.payments.history,
      firmId: state => state.user.profile.id
    }),

    payload() {
      const { id: firmId } = store.state.user.profile;
      return () => {
        return Promise.all([
          this.$store.dispatch('packagesGet'),
          this.$store.dispatch('paymentsHistoryGet', firmId),
          this.$store.dispatch('getUserBalance', firmId)
        ]);
      };
    },

    currentPlan() {
      let plans = [];
      this.packages.forEach(plan => {
        plans = plans.concat(plan.tariffs);
      });
      const currentPlan = plans.find(plan => {
        return plan.id === this.userTarif.id;
      });
      return currentPlan ? currentPlan.title : '';
    }
  },

  methods: {
    onClickReplenishBalance() {
      this.$refs.paymentModal.open();
    },

    onClickExtendPlan() {
      this.$refs.confirmModal.open();
    },

    onLoaded() {
      this.loaded = true;
    },

    changePlanConfirm() {
      store.commit('startLoad');
      new Promise((resolve, reject) => {
        apiClient
          .put(`/firms/${this.firmId}/billings/tariff`, {
            id: this.userTarif.id
          })
          .then(response => {
            if (response.data[0]) {
              window.open(response.data[0].url, '_self');
            } else {
              Promise.all([
                this.$store.dispatch('paymentsHistoryGet', this.firmId),
                this.$store.dispatch('getUserBalance', this.firmId)
              ]).then(() => {
                this.flashSuccess('Тариф изменен');
                this.$store.commit('endLoad');
              });
            }
            resolve(response);
          })
          .catch(err => {
            this.$store.commit('endLoad');
            this.flashError('Не удалось сменить тариф');
            reject(err);
          });
      });
    },

    getPackageId(rowIndex) {
      return this.packages[rowIndex].id;
    }
  },

  components: {
    PageLoader,
    PaymentsList,
    PlanModal,
    PaymentModal,
    ConfirmModal,
    PlanSelect,
    TutorialModal
  }
};
